const faqs = [
  {
    id: 1,
    q: '黑料大赛的热度排名是怎么计算的？',
    a: '我们综合考量事件的搜索指数、社交平台讨论量、媒体报道频率以及用户互动数据（点赞、评论、转发），通过加权算法生成实时热度排名。算法每日自动更新，确保排名的时效性和客观性。',
  },
  {
    id: 2,
    q: '投稿的爆料信息会保密吗？',
    a: '我们高度重视投稿者的隐私安全。所有投稿均支持匿名提交，投稿者的个人信息采用加密存储，未经本人同意绝不对外披露。同时我们会对爆料内容进行多渠道核实后再予以展示。',
  },
  {
    id: 3,
    q: '如何确定榜单上的黑料是真实的？',
    a: '我们的内容审核团队会对每条上榜信息进行多维度交叉验证，包括对比多个独立信源、追踪事件发展脉络、参考权威媒体报道等。对于未能充分核实的内容，会明确标注"待核实"标签。',
  },
  {
    id: 4,
    q: '黑料大赛有哪些内容板块？',
    a: '我们目前涵盖七大专题方向：网红翻车实录、明星恋情追踪、直播圈内幕、综艺争议现场、年度黑料盘点、品牌塌房记录和素人爆料精选。同时设有实时快讯、热度榜单、网友评论等互动模块。',
  },
  {
    id: 5,
    q: '网站内容多久更新一次？',
    a: '我们保持全天候实时更新机制，编辑团队 7×24 小时轮值监控全网热点。平均每天更新超过 50 条快讯内容，热度榜单每小时自动刷新，确保您看到的永远是最新鲜的热门爆料。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
              <i className="ri-question-answer-line"></i> 有问必答
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              常见问答
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              关于黑料大赛，你可能想知道的一切都在这里
            </p>
          </div>

          <div className="max-w-[800px] mx-auto space-y-4">
            {faqs.map((faq) => (
              <details key={faq.id} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between px-6 py-5 text-left list-none">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 pr-8">
                    {faq.q}
                  </h3>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-add-line text-lg text-foreground-500 group-open:hidden"></i>
                    <i className="ri-subtract-line text-lg text-primary-500 hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}